import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { LegaliAssociativaUpdateComponent } from './legali-associativa-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [legali-mod-associativa-update]',
  templateUrl: 'legali-mod-associativa-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LegaliModAssociativaUdate {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneLegali> = new EventEmitter<SezioneLegali>();
  @ViewChild('formAssociativa') formAssociativa: LegaliAssociativaUpdateComponent;

  inizializza(urlUpdateAnagrafica: string, legaleIncaricato: LegaleIncaricato, sezione: SezioneLegali) {
    this.formAssociativa.inizializza(urlUpdateAnagrafica, legaleIncaricato, sezione, 'edit');
    openModal('modalModAssociativaLegali');
  }

  createForm() {
   this.formAssociativa.createForm();
  }

  manageModal(sezione: SezioneLegali) {
      closeModal('modalModAssociativaLegali');
      this.onReturn.emit(sezione);
  }
}
